export default __webpack_public_path__ + "static/media/no-arhiv-campaign.1e878bfc.svg";